import { Box, Button } from '@mui/material'
import { ContainerPositionType, StowagePositionDto } from '@planning/app/api'
import { StowagePositionSubForm } from '@planning/components/stowage-position/organisms/StowagePositionSubForm'
import { StowagePositionFormData } from '@planning/components/stowage-position/stores/StowagePositionSubFormStore'
import { NavigationStackBackButton } from '@planning/pages/TallymanV2/Components'
import { useTranslate } from '@tolgee/react'
import { ContainerMobile, Header, StepperInfo, useMinimalsTheme } from '@tom-ui/ui'
import { useFormStore } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { IInspectContainerFormData } from '../InspectContainer/InspectContainerForm'

interface IProps {
  tallymanOperationsUIStore: any
  orderData: IInspectContainerFormData
  containerNumber?: string | null
  stowagePosition?: StowagePositionDto
  onSubmit: (stowagePositionFormData?: StowagePositionFormData) => void
}
export const StowagePositionStep = observer(
  ({
    tallymanOperationsUIStore,
    orderData,
    containerNumber,
    stowagePosition,
    onSubmit,
  }: IProps) => {
    const { t } = useTranslate()
    const theme = useMinimalsTheme()
    const formStore = useFormStore<IInspectContainerFormData>()

    const getCurrentStep = () => {
      if (tallymanOperationsUIStore.selectedContainerPosition === ContainerPositionType.Vessel) {
        return orderData.hasDamage ? 4 : 3
      }
      return orderData.hasDamage ? 3 : 2
    }

    const handleSubmit = () => {
      if (formStore.validate()) onSubmit(formStore.data.stowagePosition)
    }

    return (
      <>
        <Header
          leftRenderOption={<NavigationStackBackButton />}
          title={containerNumber ?? ''}
          rightRenderOption={
            <Button
              variant='contained'
              onClick={handleSubmit}
              sx={{ flex: 'none' }}
              data-cy='submit-stowage-position'
            >
              {t('checkOut', 'Check out')}
            </Button>
          }
        />
        <StepperInfo
          title={t('checkStowagePosition', 'Check stowage position')}
          steps={`${getCurrentStep()} ${t('of', 'of')} ${getCurrentStep()}`}
        ></StepperInfo>

        <ContainerMobile>
          <Box component='form' noValidate autoComplete='off' paddingY={theme.customSpacing.l}>
            <StowagePositionSubForm
              formStore={formStore}
              name='stowagePosition'
              initialValue={stowagePosition ?? orderData.stowagePosition}
            />
          </Box>
        </ContainerMobile>
      </>
    )
  },
)
